import React, { CSSProperties, useEffect, useRef } from 'react';
import { useQuery } from 'react-query';
import { isEqual, noop } from 'lodash';
import { Select, SelectProps } from 'antd'; 
import {
  getprOfferList,
  //getOfferListByCatalogID,
  getprOfferListByPrcodeAndMgid,
  prFilteringCriteria
} from '../../../services/pricing';



/*const OfferInput = ({
  params,
  onChange = noop,
  value,
  ...otherProps
}: OfferInputProps) => {
  const { data: offers, isFetching: isLoading } = useOfferList(params);

  return (
    <Select
      loading={isLoading}
      value={isNaN(value) || Number(value) === 0 ? '' : Number(value)}
      onChange={onChange}
      {...otherProps}
    >
      {offers?.map((offer) => (
        <Select.Option value={offer.offerid} key={offer.offerid}>
          {offer.offerlabel}
        </Select.Option>
      ))}
    </Select>
  );
};*/
// OfferInput.tsx

// ... autres imports

const { Option } = Select; // Décomposition de Option

export type OfferInputProps = SelectProps & {
  params: UseOfferListParams;
  disabled?: boolean;
  style?: CSSProperties;
  onOffersLoaded?: (offers: any[]) => void;
};


/*const OfferInput = ({
  params,
  onChange = noop,
  value,
  onOffersLoaded,
  ...otherProps
}: OfferInputProps) => {
  const { data: offers, isFetching: isLoading } = useOfferList(params);

  useEffect(() => {
    if (offers && onOffersLoaded) {
      onOffersLoaded(offers);
    }
  }, [offers, onOffersLoaded]);*/
const OfferInput = ({
  params,
  onChange = noop,
  value,
  onOffersLoaded,
  ...otherProps
}: OfferInputProps) => {
  const { data: offers, isFetching: isLoading } = useOfferList(params);
  const prevOffersRef = useRef<any[]>([]);

  useEffect(() => {
    if (offers && onOffersLoaded && !isEqual(offers, prevOffersRef.current)) {
      onOffersLoaded(offers);
      prevOffersRef.current = offers;
    }
  }, [offers, onOffersLoaded]);
  return (
    <Select
      loading={isLoading}
      onChange={onChange}
      value={value}
      {...otherProps}
    >
      {offers?.map((offer) => (
        <Option key={offer.offerid} value={offer.offerid}>
          {offer.offerlabel}
        </Option>
      ))}
    </Select>
  );
};
// ... reste du code
type UseOfferListParams = {
  catalogid?: number;
  duration?: number;
  filtersList?: prFilteringCriteria;
  filters?: string;
  finamount?: number;
  prcode?: string;
  searchMode: string; // PRCODE : by prcode, CATALOG : bu Catalog, FIN : by FinaMount and Duration
};

const useOfferList = (params: UseOfferListParams) => {
  const {
    prcode,
    duration,
    finamount,
    filters = '',
    filtersList,
    searchMode
  } = params;

  const getOfferListRequest = useQuery(
    ['getOfferList', { duration, filters, finamount, prcode }],
    () =>
      getprOfferList({
        duration: duration!,
        filters,
        finamount: finamount!,
        prcode: prcode!
      }).then((res) => res.list || []),
    { enabled: searchMode === 'FIN' }
  );

  /* const getOfferListByCatalogIDRequest = useQuery(
    ['getOfferListByCatalogID', { catalogid, filters, prcode }],
    () =>
      getOfferListByCatalogID({
        catalogid: catalogid!,
        filters,
        prcode: prcode!,
      }).then((res) => res.list || []),
    { enabled: searchMode === 'CATALOG' }
  );
*/
  const getOfferListByPrcodeAndMgidRequest = useQuery(
    ['getOfferListByPrcodeAndMgid', { filtersList, prcode }],
    () =>
      getprOfferListByPrcodeAndMgid({
        filters: filtersList!
      }).then((res) => res.list || []),
    { enabled: searchMode === 'PRCODE' }
  );

  switch (searchMode) {
    case 'FIN':
      return getOfferListRequest;

    /*  case 'CATALOG':
      return getOfferListByCatalogIDRequest;
*/
    case 'PRCODE':
      return getOfferListByPrcodeAndMgidRequest;
    default:
      return getOfferListByPrcodeAndMgidRequest;
  }
};

export default OfferInput;
